import { gql } from '@apollo/client';
import appraisalNotificationFragment from './fragments/appraisalNotificationFragment';
import checkpointNotificationFragment from './fragments/checkpointNotificationFragment';
import changeDateRequestEditEventReviewNotificationFragment from './fragments/changeDateRequestEditEventReviewNotificationFragment';
import changeDateRequestReviewPageNotificationFragment from './fragments/changeDateRequestReviewPageNotificationFragment';
import recentUpdatesNotificationBaseFragment from './fragments/recentUpdatesNotificationBaseFragment';
import observationReportReviewPageNotificationFragment from './fragments/observationReportReviewPageNotificationFragment';

const GET_RECENT_UPDATES_NOTIFICATIONS_QUERY = gql`
  query GetRecentUpdatesNotifications {
    recentUpdatesNotifications {
      ...RecentUpdatesNotificationBaseFields
      ...AppraisalNotificationFields
      ...CheckpointNotificationFields
      ...ChangeDateRequestEditEventReviewNotificationFields
      ...ChangeDateRequestReviewPageNotificationFields
      ...ObservationReportReviewPageNotificationFields
    }
  }

  ${recentUpdatesNotificationBaseFragment}
  ${appraisalNotificationFragment}
  ${checkpointNotificationFragment}
  ${changeDateRequestEditEventReviewNotificationFragment}
  ${changeDateRequestReviewPageNotificationFragment}
  ${observationReportReviewPageNotificationFragment}
`;

export default GET_RECENT_UPDATES_NOTIFICATIONS_QUERY;
